import React, { useState } from 'react';
import CSVReader from 'react-csv-reader';
import './ExcelImporter.css';

const ExcelImporter = ({ onDataImported }) => {
  const [fileName, setFileName] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [previewData, setPreviewData] = useState(null);

  const handleForce = (data, fileInfo) => {
    try {
      setFileName(fileInfo.name);
      setIsLoading(true);
      setError(null);
      
      // Verifica che ci siano dati
      if (data.length <= 1) {
        setError('Il file CSV non contiene dati.');
        setIsLoading(false);
        return;
      }

      // Estrae le intestazioni (prima riga)
      const headers = Object.keys(data[0]);
      
      // Imposta i dati di anteprima (primi 5 elementi)
      setPreviewData({
        headers,
        rows: data.slice(0, 5),
        totalRows: data.length
      });

      // Passa i dati al componente padre
      if (onDataImported) {
        onDataImported(data);
      }
      
      setIsLoading(false);
    } catch (err) {
      console.error('Errore durante l\'elaborazione del file:', err);
      setError('Si è verificato un errore durante l\'elaborazione del file. Assicurati che il file sia valido.');
      setIsLoading(false);
    }
  };

  const handleError = (error) => {
    console.error('Errore durante la lettura del file CSV:', error);
    setError('Si è verificato un errore durante la lettura del file CSV. Assicurati che il file sia valido.');
    setIsLoading(false);
  };

  const papaparseOptions = {
    header: true,
    dynamicTyping: false, // Mantiene tutto come stringhe per gestire meglio i formati numerici
    skipEmptyLines: true,
    transform: (value) => {
      // Rimuove spazi extra ma mantiene il valore come stringa
      return typeof value === 'string' ? value.trim() : value;
    }
  };

  return (
    <div className="excel-importer">
      <h3>Importa dati da CSV</h3>
      
      <div className="import-container">
        <CSVReader
          cssClass="csv-reader-input"
          onFileLoaded={handleForce}
          onError={handleError}
          parserOptions={papaparseOptions}
          inputId="csv-file-input"
          inputStyle={{ display: 'none' }}
        />
        
        <button 
          className="import-button" 
          onClick={() => document.getElementById('csv-file-input').click()}
        >
          Seleziona file CSV
        </button>
        
        {fileName && <span className="file-name">{fileName}</span>}
      </div>

      {isLoading && <div className="loading">Caricamento in corso...</div>}
      
      {error && <div className="error-message">{error}</div>}
      
      {previewData && (
        <div className="preview-container">
          <h4>Anteprima dati (primi 5 record di {previewData.totalRows})</h4>
          <div className="table-container">
            <table className="preview-table">
              <thead>
                <tr>
                  {previewData.headers.map((header, index) => (
                    <th key={index}>{header}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {previewData.rows.map((row, rowIndex) => (
                  <tr key={rowIndex}>
                    {previewData.headers.map((header, colIndex) => (
                      <td key={colIndex}>{row[header]}</td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default ExcelImporter;